import createSelector from 'lib/createSelector'
import { isOrganicSearch } from 'lib/search/searchUtils'
import {
  isAndroid,
  isApple,
  isIOS,
  isMobile,
} from 'lib/deviceUtils'

export const hasOrganicReferrer = createSelector(
  (state: App.State) => state.config.referrer,
  (referrer) => isOrganicSearch(referrer),
)

export const isAndroidSel = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => isAndroid(userAgent.osName),
)

export const isAppleSel = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => isApple(userAgent.osName),
)

export const isIOSSel = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => isIOS(userAgent.osName),
)

export const isMobileSel = createSelector(
  (state: App.State) => state.config.userAgent,
  (userAgent) => isMobile(userAgent.osName),
)

export const isHeadlessModeSel = createSelector(
  (state: App.State) => state.config.headlessMode,
  (headlessMode) => headlessMode,
)

export const isMobileAppSel = createSelector(
  isMobileSel,
  isHeadlessModeSel,
  (isMobileSel, isHeadlessModeSel) => isMobileSel && isHeadlessModeSel,
)
